import { VALIDATION } from "constants/messages";
import * as yup from "yup";
const poRegExp = /^[0-9a-zA-Z(\-) ]+$/;

export const InspectionRequestSchema = yup.object().shape({
  project_name: yup.string().required().min(1).max(50).label("Project Name"),
  no_machine: yup
    .number()
    .typeError("No. of machines must be a number.")
    .required("No. of machines is a required field")
    .min(1)
    .label("No. of machines"),
  job_contact: yup.string().min(1).max(50).label("Job contact"),
  po_no: yup
    .string()
    .typeError(VALIDATION.poNumberAlphanumeric)
    .label("PO No.")
    .matches(poRegExp, VALIDATION.poNumberAlphanumeric),
  ordered_by: yup.string().label("Ordered by"),
  // inspection_datetime: yup.string().label("Date & Time"),
  // job_location: yup.string(),
  job_location_address: yup
    .string()
    .required()
    .min(1)
    .max(100)
    .label("Address"),
  job_location_city: yup.string().required().min(1).max(20).label("City"),
  job_location_state: yup.number().required().label("State/Province"),
  job_location_zip_code: yup.string().required().min(1).max(10).label("Zip"),
  job_location_comment: yup.string().label("Comments"),
});

export const AddMachineSchema = yup.object().shape({
  device_id: yup.string().max(255).label("Device ID"),
  make: yup.string().required().max(255).label("Make"),
  model_number: yup.string().required().max(255).label("Model no."),
  serial_number: yup.string().required().max(255).label("Serial no."),
  inspection_type: yup.string().required().max(255).label("Inspection Type"),
});

export const TravelInformationExpensesSchema = yup.object().shape({
  tolls_cost: yup
    .number()
    .min(0)
    .label("Tolls")
    .typeError(VALIDATION.tollsCost),
  meals_cost: yup
    .number()
    .min(0)
    .label("Meals")
    .typeError(VALIDATION.mealsCost),
  lodging_cost: yup
    .number()
    .min(0)
    .label("Lodging")
    .typeError(VALIDATION.lodgingCost),
  mileage_cost: yup
    .number()
    .min(0)
    .label("Mileage")
    .typeError(VALIDATION.mileageCost),
  misc_cost: yup.number().min(0).label("Misc.").typeError(VALIDATION.miscCost),
});

function parseDate(value: any, originalValue: any): Date | null | undefined {
  if (value === null || value === undefined || value === "") {
    return undefined;
  }

  const date = new Date(value);
  return isNaN(date.getTime()) ? null : date;
}

export const TravelInformationSchema = yup.object().shape({
  description: yup.string().label("Description"),
  travel_start: yup
    .date()
    .nullable()
    .transform(parseDate)
    .required()
    .label("Travel start"),
  inspection_start: yup
    .date()
    .nullable()
    .transform(parseDate)
    .required()
    .label("Inspection start")
    .when("travel_start", (travel_start, schema: yup.DateSchema) => {
      if (travel_start && travel_start[0] !== null)
        return schema.min(travel_start, VALIDATION.inspectionStart);
      return schema;
    }),
  inspection_stop: yup
    .date()
    .nullable()
    .transform(parseDate)
    .required()
    .label("Inspection stop")
    .when("inspection_start", (inspection_start, schema: yup.DateSchema) => {
      if (inspection_start && inspection_start[0] !== null)
        return schema.min(inspection_start, VALIDATION.inspectionStop);
      return schema;
    }),
  travel_stop: yup
    .date()
    .nullable()
    .transform(parseDate)
    .required()
    .label("Travel stop")
    .when("inspection_stop", (inspection_stop, schema: yup.DateSchema) => {
      if (inspection_stop && inspection_stop[0] !== null)
        return schema.min(inspection_stop, VALIDATION.travelStop);
      return schema;
    }),
});

export const machineImageValidation = yup.object().shape({
  files: yup.mixed().required(VALIDATION.fileIsRequired),
});

export const TravelNotesSchema = yup.object().shape({
  travel_notes: yup.string().required().label("Notes"),
});


export const shareModelSchema = yup.object().shape({
  emails: yup.array()
    .of(yup.string().email('Invalid email format'))
    .test('at-least-one-email',  VALIDATION.userEmailsRequire, (value) => {
      return Array.isArray(value) && value.length > 0;
    })
    .test('maximun-30-email',  VALIDATION.maximumEmailError, (value) => {
      return Array.isArray(value) && value.length <= 30;
    })
    .typeError(VALIDATION.userEmailsRequire)
});